import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Collapse,
	RootRef,
	Button,
	Grid
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	hidden: {
		display: "none"
	},

	button: {
		marginLeft: theme.spacing(-1)
	},

	inline: {
		right: "-0.5em",
		position: "absolute",
		marginTop: theme.spacing(-3.5)
	},

	collapse: {
		marginBottom: theme.spacing(1)
	},

	truncate: {
		//position: "relative",

		/* place for '...' */
		marginRight: "-1em",
		paddingRight: "6.8em", //1em",
		//wordBreak: "break-word",

		/*"&:before": {
			content: "'...'",
			position: "absolute",
			// set position to right bottom corner of block
			right: "6em", //0,
			bottom: -5, //0
			background: theme.palette.common.white
		}*/
	}
}));

function MoreOrLess(props) {
	const contentDiv = useRef();
	const [truncate, setTruncate] = useState(false);
	const [showMore, setShowMore] = useState(false);

	const isTruncateNeeded = useCallback(() => {
		let height = contentDiv.current && contentDiv.current.getBoundingClientRect().height;
		setShowMore(props.expanded);
		setTruncate(height > props.truncateHeight || props.hasImage);
	}, [contentDiv, props.expanded, props.truncateHeight, props.hasImage]);

	useEffect(() => {
		setTimeout(() => {
			isTruncateNeeded();
		}, 0);
	}, [isTruncateNeeded]);

	const toggleReadMore = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setShowMore(!showMore);
	};

	let classes = styles(),
		{truncateHeight, content, inline, moreLabel, lessLabel, right} = props;

	moreLabel = inline ? `... ${moreLabel}` : moreLabel;

	let moreBtn = (
			<Button
				size="small"
				color="primary"
				className={`${classes.button} ${showMore === true ? classes.hidden : null}`}
				onClick={toggleReadMore}>{moreLabel}</Button>
		),
		lessBtn = (
			<Button
				size="small"
				color="primary"
				className={`${classes.button} ${showMore === true ? null : classes.hidden}`}
				onClick={toggleReadMore}>{lessLabel}</Button>
		);

	return (
		<React.Fragment>
			<Collapse
				in={showMore}
				style={{height: truncateHeight}}
				collapsedHeight={`${truncateHeight}px`}
				className={`${classes.collapse} ${truncate && inline ? classes.truncate : null}`}>
				<RootRef rootRef={contentDiv}>
					{content}
				</RootRef>
			</Collapse>
			{truncate === true ? (
				<Grid container
					justify={right || inline ? "flex-end" : "flex-start"}
					className={inline ? classes.inline : null}>
					<Grid item>{moreBtn}</Grid>
					<Grid item>{lessBtn}</Grid>
				</Grid>
			) : null}
		</React.Fragment>
	);
}

MoreOrLess.defaultProps = {
	inline: false,
	expanded: false,
	right: false,
	truncateHeight: 200,
	moreLabel: "Show More",
	lessLabel: "Show Less"
};

MoreOrLess.propTypes = {
	truncateHeight: PropTypes.number,
	content: PropTypes.any,
	expanded: PropTypes.bool,
	inline: PropTypes.bool,
	moreLabel: PropTypes.string,
	lessLabel: PropTypes.string,
	right: PropTypes.bool,
	hasImage: PropTypes.bool
};

export default MoreOrLess;